webpackJsonp([38],{

/***/ 1108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//


function created() {
	var _this = this;

	if (this.realTime) {
		this.intervalId = setInterval(function () {
			_this.$emit('increase-time');
		}, 1000);
	}
}

function data() {
	return {
		intervalId: null
	};
}

function formatTime(value) {
	return value < 10 ? '0' + value : value;
}

function destroyed() {
	clearInterval(this.intervalId);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	created: created,
	data: data,
	destroyed: destroyed,
	filters: {
		formatTime: formatTime
	},
	name: 'clock',
	props: {
		minute: {
			type: Number,
			default: 0
		},
		second: {
			type: Number,
			default: 0
		},
		realTime: {
			type: Boolean,
			default: true
		}
	}
});

/***/ }),

/***/ 1110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DetailDescription__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DetailDescription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DetailDescription__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		DetailDescription: __WEBPACK_IMPORTED_MODULE_0__DetailDescription___default.a
	},
	name: 'list-detail-description',
	props: {
		details: {
			type: Array,
			required: true
		}
	}
});

/***/ }),

/***/ 1111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'media',
	props: {
		item: {
			type: Object,
			required: true
		}
	}
});

/***/ }),

/***/ 1160:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".clock-container[data-v-20aa2ce3]{display:-webkit-box;display:-ms-flexbox;display:flex}.clock-container p[data-v-20aa2ce3]{margin:0}.clock-container .time-container[data-v-20aa2ce3]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-left:11px}.clock-container .time-container .label[data-v-20aa2ce3]{color:#353c4c;font-family:San Francisco Display Medium;font-size:14px;font-weight:500;line-height:1}.clock-container .time-container .time[data-v-20aa2ce3]{color:gray;font-family:Conv_sf_compact_displayultralight;font-size:40px;font-weight:200;line-height:.8}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/Clock.vue"],"names":[],"mappings":"AACA,kCACE,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,oCACI,QAAU,CACb,AACD,kDACI,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,gBAAkB,CACrB,AACD,yDACM,cAAe,AACf,yCAA4C,AAC5C,eAAgB,AAChB,gBAAiB,AACjB,aAAe,CACpB,AACD,wDACM,WAAe,AACf,8CAAiD,AACjD,eAAgB,AAChB,gBAAiB,AACjB,cAAiB,CACtB","file":"Clock.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.clock-container[data-v-20aa2ce3] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.clock-container p[data-v-20aa2ce3] {\n    margin: 0;\n}\n.clock-container .time-container[data-v-20aa2ce3] {\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    margin-left: 11px;\n}\n.clock-container .time-container .label[data-v-20aa2ce3] {\n      color: #353c4c;\n      font-family: \"San Francisco Display Medium\";\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 1;\n}\n.clock-container .time-container .time[data-v-20aa2ce3] {\n      color: #808080;\n      font-family: \"Conv_sf_compact_displayultralight\";\n      font-size: 40px;\n      font-weight: 200;\n      line-height: 0.8;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1162:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".media-title[data-v-500c348e]{height:auto}.media-avatar[data-v-500c348e]{padding-top:0!important}.media-avatar img[data-v-500c348e]{height:47px!important;width:47px!important}.subtitle-key[data-v-500c348e]{color:#353c4c;font-family:San Francisco Display Medium}.subtitle-value[data-v-500c348e]{color:#29abe2;padding-left:5px;padding-right:26px}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/Media.vue"],"names":[],"mappings":"AACA,8BACE,WAAa,CACd,AACD,+BACE,uBAA4B,CAC7B,AACD,mCACI,sBAAwB,AACxB,oBAAuB,CAC1B,AACD,+BACE,cAAe,AACf,wCAA4C,CAC7C,AACD,iCACE,cAAe,AACf,iBAAkB,AAClB,kBAAoB,CACrB","file":"Media.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.media-title[data-v-500c348e] {\n  height: auto;\n}\n.media-avatar[data-v-500c348e] {\n  padding-top: 0px !important;\n}\n.media-avatar img[data-v-500c348e] {\n    height: 47px !important;\n    width: 47px !important;\n}\n.subtitle-key[data-v-500c348e] {\n  color: #353c4c;\n  font-family: \"San Francisco Display Medium\";\n}\n.subtitle-value[data-v-500c348e] {\n  color: #29abe2;\n  padding-left: 5px;\n  padding-right: 26px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1165:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1160);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("49035261", content, true);

/***/ }),

/***/ 1167:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1162);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("7619aa6a", content, true);

/***/ }),

/***/ 1172:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1165)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1108),
  /* template */
  __webpack_require__(1177),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-20aa2ce3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1174:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1110),
  /* template */
  __webpack_require__(1181),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1175:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1167)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1111),
  /* template */
  __webpack_require__(1179),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-500c348e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1177:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clock-container"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/clock.png",
      "alt": "clock",
      "width": "47",
      "height": "47"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "time-container"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("Tiempo:")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("formatTime")(_vm.minute)) + ":" + _vm._s(_vm._f("formatTime")(_vm.second)) + "\n\t\t")])])])
},staticRenderFns: []}

/***/ }),

/***/ 1179:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "transparent py-0",
    attrs: {
      "two-line": ""
    }
  }, [(_vm.item.avatar) ? _c('v-list-tile', {
    attrs: {
      "avatar": "",
      "download": ""
    }
  }, [_c('v-list-tile-avatar', {
    staticClass: "media-avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.item.avatar
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "media-title"
  }, [_c('h5', {
    staticClass: "semibold-blue-title-30"
  }, [_vm._v(_vm._s(_vm.item.title))])]), _vm._v(" "), _c('v-list-tile-sub-title', _vm._l((_vm.item.subtitles), function(subtitle) {
    return _c('span', {
      key: subtitle.key
    }, [_c('span', {
      staticClass: "subtitle-key"
    }, [_vm._v(_vm._s(subtitle.key) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "subtitle-value"
    }, [_vm._v(_vm._s(subtitle.value))])])
  }))], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1181:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, _vm._l((_vm.details), function(detail) {
    return _c('detail-description', {
      key: detail.label,
      attrs: {
        "icon": detail.icon,
        "label": detail.label,
        "description": detail.description
      }
    })
  }))
},staticRenderFns: []}

/***/ }),

/***/ 1355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_ButtonCreate__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_ButtonCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_ButtonCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_Clock__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_Clock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_shared_Clock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_ListDetailDescription__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_ListDetailDescription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_shared_ListDetailDescription__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_FilterList__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_FilterList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_shared_FilterList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_Media__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_Media___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_shared_Media__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_RoomStatus__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_RoomStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_shared_RoomStatus__);



var loadData = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(search) {
		var response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return this.$http.get('room/' + this.roomId + '/detail', { params: { search: search } });

					case 3:
						response = _context.sent;

						this.room = response.data;
						this.rows = response.data.history;
						_context.next = 11;
						break;

					case 8:
						_context.prev = 8;
						_context.t0 = _context['catch'](0);

						this.showNotification('Error interno de servidor, por favor recargue la pagina e intentelo de nuevo', 'error');

					case 11:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 8]]);
	}));

	return function loadData(_x) {
		return _ref2.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











function created() {
	this.loadData();
}

function columnSortableEvent(_ref) {
	var _this = this;

	var id = _ref.id;

	setTimeout(function () {
		var newData = [];
		var newColumn = _this.columns.filter(function (column) {
			return column.id === id;
		});
		newColumn[0].isSortable = newColumn[0].isSortable.down ? { down: false, up: true } : { down: true, up: false };
		var columnName = newColumn[0].code;
		if (newColumn[0].isSortable.up) {
			newData = _this.rows.sort(function (a, b) {
				if (typeof a[columnName] === 'number' && typeof b[columnName] === 'number') {
					return a[columnName] - b[columnName];
				}
				return a[columnName].charCodeAt() - b[columnName].charCodeAt();
			});
		} else {
			newData = _this.rows.sort(function (a, b) {
				if (typeof a[columnName] === 'number' && typeof b[columnName] === 'number') {
					return b[columnName] - a[columnName];
				}
				return b[columnName].charCodeAt() - a[columnName].charCodeAt();
			});
		}
		_this.rows = newData;
	}, 300);
}

function increaseTime() {
	if (this.room.time_second === 59) {
		this.room.time_minute += 1;
		this.room.time_second = 0;
	} else {
		this.room.time_second += 1;
	}
}

function onSearchData(value) {
	this.loadData(value);
}

function openRoomPhotos(row) {
	this.$router.push({ name: 'room-photos', params: { roomId: this.room.id, roomNumber: this.room.number, maidId: row.id } });
}

function mediaItem() {
	var media = {
		avatar: '/static/img/bed-icon.png',
		title: 'Habitacion ' + this.room.roomtype_name + ' - ' + this.room.number,
		subtitles: [],
		details: []
	};
	if (this.room.maid) {
		media.subtitles.push({
			key: 'Mucama',
			value: this.room.maid.name
		});
		media.subtitles.push({
			key: 'Estado',
			value: this.room.maid.state_name
		});
		media.details.push({
			description: this.room.maid.type_clean,
			icon: 'type-clean',
			label: 'Tipo de Limpieza'
		});
		media.details.push({
			description: this.room.maid.date,
			icon: 'date',
			label: 'Fecha'
		});
		media.details.push({
			description: this.room.maid.standard_time,
			icon: 'time-standard',
			label: 'Tiempo Standard'
		});
		media.details.push({
			description: this.room.maid.supervisor,
			icon: 'supervisor',
			label: 'Supervisora'
		});
	}
	return media;
}

function selectedFilter(filter) {
	this.filterValue = filter.id;
}

/* harmony default export */ __webpack_exports__["default"] = ({
	created: created,
	name: 'room-detail',
	components: {
		ButtonCreate: __WEBPACK_IMPORTED_MODULE_4__components_shared_ButtonCreate___default.a,
		Clock: __WEBPACK_IMPORTED_MODULE_5__components_shared_Clock___default.a,
		FilterList: __WEBPACK_IMPORTED_MODULE_7__components_shared_FilterList___default.a,
		ListDetailDescription: __WEBPACK_IMPORTED_MODULE_6__components_shared_ListDetailDescription___default.a,
		Media: __WEBPACK_IMPORTED_MODULE_8__components_shared_Media___default.a,
		RoomStatus: __WEBPACK_IMPORTED_MODULE_9__components_shared_RoomStatus___default.a,
		TableRun: __WEBPACK_IMPORTED_MODULE_2_table_run___default.a
	},
	computed: {
		mediaItem: mediaItem
	},
	data: function data() {
		return {
			columns: [{ id: 1, name: 'Mucamas', code: 'name', isSortable: { down: true, up: false } }, { id: 2, name: 'Fecha', code: 'date', isSortable: { down: true, up: false } }, { id: 3, name: 'Tipo de limpieza', code: 'clean_type', isSortable: { down: true, up: false } }, { id: 4, name: 'Tiempo estandar', code: 'time_standard', isSortable: { down: true, up: false } }, { id: 5, name: 'Tiempo realizado', code: 'time_done', isSortable: { down: true, up: false } }, { id: 6, name: 'Supervisor', code: 'supervisor', isSortable: { down: true, up: false } }],
			rows: [],
			item: {
				avatar: '/static/img/bed-icon.png',
				title: 'Habitación 111 - Deluxe Suite Queen',
				subtitles: [{
					key: 'Mucama',
					value: 'María Chiappe'
				}, {
					key: 'Estado',
					value: 'En curso'
				}]
			},
			time: '00:45',
			filterValue: 1,
			room: {
				id: 1,
				roomtype_name: '',
				number: '',
				code: '',
				icon: '',
				extra_state: '',
				clean_state: 0,
				time: '00:00'
			}
		};
	},

	methods: {
		columnSortableEvent: columnSortableEvent,
		increaseTime: increaseTime,
		loadData: loadData,
		onSearchData: onSearchData,
		openRoomPhotos: openRoomPhotos,
		selectedFilter: selectedFilter
	},
	mixins: __WEBPACK_IMPORTED_MODULE_3__shared_mixins__["a" /* default */],
	props: ['roomId']
});

/***/ }),

/***/ 1415:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".time-container[data-v-69f9fb9b]{padding-left:17px;width:165px}", "", {"version":3,"sources":["/opt/build/repo/src/housekeeping/rooms/RoomDetail.vue"],"names":[],"mappings":"AACA,iCACE,kBAAmB,AACnB,WAAa,CACd","file":"RoomDetail.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.time-container[data-v-69f9fb9b] {\n  padding-left: 17px;\n  width: 165px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1500:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1415);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("285a951b", content, true);

/***/ }),

/***/ 1661:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "room-detail"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-3": "",
      "align-items-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md8": ""
    }
  }, [_c('media', {
    attrs: {
      "item": _vm.mediaItem
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-items-center": ""
    }
  }, [_c('div', {
    staticClass: "pr-2"
  }, [_c('room-status', {
    staticClass: "mb-0",
    attrs: {
      "clean-state": _vm.room.clean_state,
      "number": _vm.room.number,
      "code": _vm.room.code,
      "status-icon": _vm.room.icon,
      "room": _vm.room,
      "size": 'medium',
      "extra-state": _vm.room.extra_state,
      "name": _vm.room.name
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "time-container body-border-left"
  }, [_c('clock', {
    attrs: {
      "minute": _vm.room.time_minute,
      "second": _vm.room.time_second
    },
    on: {
      "increase-time": _vm.increaseTime
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('list-detail-description', {
    staticClass: "px-2 mb-3",
    attrs: {
      "details": _vm.mediaItem.details
    }
  })], 1), _vm._v(" "), _c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "selectable": false,
      "include-delete": false,
      "include-export-to-excel": true,
      "include-options": true,
      "include-state": true,
      "include-images": true
    },
    on: {
      "on-search-event": _vm.onSearchData,
      "go-to-photos-page": _vm.openRoomPhotos,
      "on-sortable-event": _vm.columnSortableEvent
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.name) + " " + _vm._s(props.row.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.clean_type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.time_standard))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.time_done))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.supervisor))])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 859:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1500)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1355),
  /* template */
  __webpack_require__(1661),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-69f9fb9b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 927:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'detail-description',
	props: {
		icon: {
			type: String,
			required: true
		},
		label: {
			type: String,
			required: true
		},
		description: {
			type: [Date, String, Number],
			required: true
		}
	}
});

/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".container-icon-description[data-v-3133e480]{border-radius:100%;display:inline-block;font-size:inherit;height:17px;letter-spacing:inherit;line-height:inherit;padding-top:0;text-align:center;width:17px}.container-icon-description.type-clean[data-v-3133e480]{background-color:#f6a623}.container-icon-description.date[data-v-3133e480]{background-color:#f6232a}.container-icon-description.time-standard[data-v-3133e480]{background-color:#25d90a}.container-icon-description.time-done[data-v-3133e480]{background-color:#0aceff}.container-icon-description.supervisor[data-v-3133e480]{background-color:#0f64e2}.key-description[data-v-3133e480]{color:#818181;margin:0 2px 0 5px}.key-description[data-v-3133e480],.value-description[data-v-3133e480]{font-family:San Francisco Display;font-size:14px;line-height:inherit;padding-top:0}.value-description[data-v-3133e480]{color:#353c4c;text-transform:capitalize}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/DetailDescription.vue"],"names":[],"mappings":"AACA,6CACE,mBAAoB,AACpB,qBAAsB,AACtB,kBAAmB,AACnB,YAAa,AACb,uBAAwB,AACxB,oBAAqB,AACrB,cAAiB,AACjB,kBAAmB,AACnB,UAAY,CACb,AACD,wDACI,wBAA0B,CAC7B,AACD,kDACI,wBAA0B,CAC7B,AACD,2DACI,wBAA0B,CAC7B,AACD,uDACI,wBAA0B,CAC7B,AACD,wDACI,wBAA0B,CAC7B,AACD,kCACE,cAAe,AAIf,kBAAwB,CAEzB,AACD,sEANE,kCAAqC,AACrC,eAAgB,AAChB,oBAAqB,AAErB,aAAiB,CASlB,AAPD,oCACE,cAAe,AAKf,yBAA2B,CAC5B","file":"DetailDescription.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.container-icon-description[data-v-3133e480] {\n  border-radius: 100%;\n  display: inline-block;\n  font-size: inherit;\n  height: 17px;\n  letter-spacing: inherit;\n  line-height: inherit;\n  padding-top: 0px;\n  text-align: center;\n  width: 17px;\n}\n.container-icon-description.type-clean[data-v-3133e480] {\n    background-color: #f6a623;\n}\n.container-icon-description.date[data-v-3133e480] {\n    background-color: #f6232a;\n}\n.container-icon-description.time-standard[data-v-3133e480] {\n    background-color: #25d90a;\n}\n.container-icon-description.time-done[data-v-3133e480] {\n    background-color: #0aceff;\n}\n.container-icon-description.supervisor[data-v-3133e480] {\n    background-color: #0f64e2;\n}\n.key-description[data-v-3133e480] {\n  color: #818181;\n  font-family: \"San Francisco Display\";\n  font-size: 14px;\n  line-height: inherit;\n  margin: 0px 2px 0px 5px;\n  padding-top: 0px;\n}\n.value-description[data-v-3133e480] {\n  color: #353c4c;\n  font-family: \"San Francisco Display\";\n  font-size: 14px;\n  line-height: inherit;\n  padding-top: 0px;\n  text-transform: capitalize;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 936:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(933);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("03f6ff8c", content, true);

/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(936)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(927),
  /* template */
  __webpack_require__(942),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3133e480",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 942:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-inline-flex align-items-center"
  }, [(_vm.icon) ? _c('span', {
    class: ("container-icon-description " + _vm.icon)
  }, [_c('span', {
    class: ("sprite-icons " + _vm.icon)
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "key-description"
  }, [_vm._v(_vm._s(_vm.label) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "value-description"
  }, [_vm._v(_vm._s(_vm.description))])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/38.c2a277e19c34dca5f731.js